/** Formats seconds as a short human-readable duration (e.g. "5m 12s", "1h 2m"). */
export function formatDurationSeconds(total: number | null | undefined): string | null {
  if (total == null || total < 0) return null;
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

/** Formats an ISO timestamp for session review (locale-aware). */
export function formatSessionDateTime(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString(undefined, {
    dateStyle: 'long',
    timeStyle: 'short',
  });
}

/** Prefer practice start time; fall back to record creation time. */
export function getSessionStartIso(session: {
  startedAt?: string | null;
  createdAt: string | null;
}): string | null {
  return session.startedAt ?? session.createdAt ?? null;
}
